import React from 'react';
import {
  CircleNotch
} from '@phosphor-icons/react';

/**
 * AuthLoadingScreen - Full-page loading splash during auth verification
 * 
 * CRITICAL: Uses position: fixed to prevent any blank flash during transitions.
 * This component covers the entire viewport with a solid background matching
 * the app theme, ensuring no white/blank frames are ever visible.
 * 
 * Shown while authStatus === "checking" to prevent login page flash
 * during AuthProvider remount (login/logout/invite accept).
 */
const AuthLoadingScreen = () => {
  return (
    <div 
      className="fixed inset-0 bg-[#121820] flex items-center justify-center z-[9999]"
      style={{ 
        // Ensure solid background - no transparency that could show blank underneath
        backgroundColor: '#121820',
        // Cover entire viewport
        minHeight: '100vh',
        minWidth: '100vw'
      }}
    >
      <div className="text-center">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="w-12 h-12 bg-transparent rounded-lg flex items-center justify-center overflow-hidden flex-shrink-0">
            <img 
              src="/man-and-machine-logo.png" 
              alt="Man & Machine Logo" 
              className="w-full h-full object-contain"
              style={{ 
                maxWidth: '100%', 
                maxHeight: '100%',
                aspectRatio: '1/1'
              }}
            />
          </div>
          <div className="flex-shrink-0">
            <span className="text-lg font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              <span className="text-white">MAN</span>
              <span className="text-[#00E5C0] mx-1">&</span>
              <span className="text-white">MACHINE</span>
            </span>
          </div>
        </div>
        
        {/* Spinner */}
        <CircleNotch size={40} className="text-[#00E5C0] animate-spin mx-auto mb-4" />
        
        {/* Loading text */}
        <p className="text-[#A0AEC0] text-sm">Please wait...</p>
      </div>
    </div>
  );
};

export default AuthLoadingScreen;
